import styled from 'styled-components'

interface ISpendTrackerCategoryCardStyledProps {}

export const SpendTrackerCategoryCardStyled = styled.div<ISpendTrackerCategoryCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
